import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(require('vue-cookies'))

new Vue({
  router,
  store,
  methods: {
    cookies: function () {
      return window.$cookies
    }
  },
  render: h => h(App)
}).$mount('#app')
